import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.048 8.3 8.3 0 0 0 9 9.6a8.98 8.98 0 0 1 3.361-6.867 8.2 8.2 0 0 0 3 2.48z"
    }, null, -1),
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 18a3.75 3.75 0 0 0 .495-7.467 6 6 0 0 0-1.925 3.546 6 6 0 0 1-2.133-1A3.75 3.75 0 0 0 12 18"
    }, null, -1)
  ]))]))
}
export default { render: render }